module.exports = __webpack_public_path__ + "img/hyperx-pulsefire-dart-preview.741e7dbc.png";